import { DateTime } from 'luxon';

export function getCalendarDayFromIsoDate(date?: string) {
  const parsedDate = DateTime.fromISO(date || '');

  if (parsedDate.isValid) {
    return parsedDate.toISODate() || '';
  }

  return DateTime.local().toISODate() || '';
}

export function getMonthAnchorFromCalendarDay(day: string) {
  return DateTime.fromISO(day).startOf('month').toISODate() || '';
}
